<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="ct-stage">
        <div class="ct-ring">
          <svg viewBox="0 0 100 100" class="ct-ring-svg" aria-hidden="true">
            <circle
              cx="50"
              cy="50"
              r="44"
              class="ct-ring-track"
            />
            <circle
              cx="50"
              cy="50"
              r="44"
              class="ct-ring-fill"
            />
          </svg>
          <div class="ct-digits">
            <span class="ct-digit ct-digit--a">10</span>
            <span class="ct-digit ct-digit--b">9</span>
            <span class="ct-digit ct-digit--c">8</span>
          </div>
        </div>
        <span class="ct-label"></span>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewCountdownTimer',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.ct-stage {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 150px;
}
.ct-ring {
  position: relative;
  width: 110px;
  height: 110px;
}
.ct-ring-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}
.ct-ring-track {
  fill: none;
  stroke: rgba(15, 15, 20, 0.08);
  stroke-width: 8;
}
.ct-ring-fill {
  fill: none;
  stroke: var(--accent);
  stroke-width: 8;
  stroke-linecap: round;
  stroke-dasharray: 276.46;
  stroke-dashoffset: 0;
  animation: ct-ring 3s linear infinite;
}
.ct-digits {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
}
.ct-digit {
  position: absolute;
  font-size: 36px;
  font-weight: 800;
  color: rgba(15, 15, 20, 0.85);
  font-variant-numeric: tabular-nums;
  opacity: 0;
}
.ct-digit--a { animation: ct-d-a 3s steps(1) infinite; }
.ct-digit--b { animation: ct-d-b 3s steps(1) infinite; }
.ct-digit--c { animation: ct-d-c 3s steps(1) infinite; }

.ct-label {
  display: block;
  height: 8px;
  width: 30%;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.18);
}

@keyframes ct-ring {
  0%   { stroke-dashoffset: 0; }
  100% { stroke-dashoffset: 276.46; }
}
@keyframes ct-d-a {
  0%, 33.32%   { opacity: 1; }
  33.33%, 100% { opacity: 0; }
}
@keyframes ct-d-b {
  0%, 33.32%        { opacity: 0; }
  33.33%, 66.65%    { opacity: 1; }
  66.66%, 100%      { opacity: 0; }
}
@keyframes ct-d-c {
  0%, 66.65%   { opacity: 0; }
  66.66%, 100% { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .ct-ring-fill { animation: none; stroke-dashoffset: 92.15; }
  .ct-digit--a, .ct-digit--c { animation: none; opacity: 0; }
  .ct-digit--b { animation: none; opacity: 1; }
}
</style>
